var map = {
	"./ar.png": "31dff",
	"./bg.png": "1d68",
	"./ca.png": "7505",
	"./ch.png": "0da0",
	"./de.png": "72fe",
	"./dk.png": "7d08",
	"./el.png": "de9b",
	"./en.png": "9996",
	"./es.png": "20ca",
	"./fr.png": "26fc",
	"./in.png": "17c5",
	"./it.png": "7ba1",
	"./ja.png": "c66c",
	"./pt.png": "5e3c",
	"./ru.png": "0b39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";